<template>
  <div class="container-fluid no-gutters p-0 m-0">
    <div class="col-12 no-gutters p-0">
      <nav style="background-color: #ffffff !important; margin: 0"
           class="navbar pt-0 pb-0 navbar-expand-lg pl-0 pr-0 w-100
       navbar-light bg-light">
        <a class="navbar-brand pt-0 pb-0 " href="#">
          <!-- 公司logo -->
          <img src="../../public/images/logo.png" alt="Logo" class="responsive-image ml-5 logo-class">
        </a>
        <button class="navbar-toggler" type="button"
                data-toggle="collapse"
                data-target="#navbarNav"
                @click="collapse"
                aria-controls="navbarNav" aria-expanded="true" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <!--      <ul class="navbar-nav ml-auto">-->
          <ul class="navbar-nav ml-auto justify-content-end">
            <li class="nav-item" v-for="item in navItems" :key="item.path">
              <router-link style="color: #01487E !important;" :to="item.path"
                           :class="{'nav-link active nav-active': $route.path === item.path, 'nav-link': true}">
                {{ $t(item.messageKey) }}
              </router-link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: null, // 用于跟踪当前激活的导航项索引
      navItems: this.$router.options.routes.map(route => ({
        path: route.path,
        messageKey: route.meta.messageKey
      }))
    };
  },
  methods: {
    collapse() {
      // 触发展开
      document.getElementById('navbarNav').classList.toggle('show');
    },
  },
};
</script>

<style scoped>


/* 导航链接激活时的样式 */
.nav-active {
  color: #01487E; /* 设置为暗红色 */
}

/*.responsive-image {
  !* 使用object-fit来确保图片填充整个容器，同时保持宽高比 *!
  padding: 0;
  margin: 0 auto;
}*/

.nav-link {
  position: relative; /* 允许伪元素定位 */
  display: block; /* 确保整个链接区域都能响应 */
  color: red;
  /* 其他样式，如颜色、内边距等 */
}

.nav-link.active:after,
.nav-link.nav-active:after {
  content: ""; /* 伪元素需要内容才能显示 */
  position: absolute;
  bottom: 0; /* 定位到链接底部 */
  left: 0;
  right: 0; /* 宽度与链接相同 */
  height: 2px; /* 边框高度 */
  background-color: rgb(29, 157, 231); /* 边框颜色 */
}

/* 默认样式，针对小屏幕（假设这里指的是Bootstrap的xs或sm断点以下） */
.logo-class {
margin-left: 7rem !important;
    width: 13.1vw;
    height: 7vw;
}


/* 中等屏幕及以上（这里我们假设中等屏幕是指Bootstrap的md及以上断点）
   Bootstrap4的md断点大约是768px，可以根据需要调整 */
@media (max-width: 768px) {
  #navbarNav{
    font-size: 2em;
  }
  .logo-class {
    margin-left: 7rem !important;
    width: 13.1vw;
    height:9vh
  }
}

@media (max-width: 576px) {
  #navbarNav{
    font-size: 2em;
  }

  .logo-class {
    margin-left: 2rem !important;
    width: 10.1vh;
    height: 5vh;
  }
}

/* 如果需要更精确地控制每个断点，可以添加更多的媒体查询 */
/* 例如，对于大屏幕（lg及以上） */
@media (min-width: 992px) {
 #navbarNav{
    font-size: 2em;
  }

  /* 如果需要的话，可以添加特定样式 */
   .navbar-nav{
    margin-right: 10%;
    font-size: 24px;
  }
  .nav-item{
    margin-right: 20px;
  }
}

/* 对于超大屏幕（xl） */
@media (min-width: 1200px) {
  /* 如果需要的话，可以添加特定样式 */

 
  .navbar-nav{
    margin-right: 10%;
       font-size: 24px;
  }
  .nav-item{
    margin-right: 20px;
  }
}
</style>